import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import { SnackbarProvider, useSnackbar } from 'notistack';
import Navbar from '../../../components/Navbar';
import Background from '../../../components/Background';
import Container from '../../../components/Container';
import Header from '../../../components/Header';
import moment from 'moment';
import style from './DashboardNitrato.module.css';
import Logo from './logo.png';
import { useNavigate, useParams } from "react-router-dom";

const DashboardNitrato = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [carregamentos, setCarregamentos] = useState([]);
  const [filteredCarregamentos, setFilteredCarregamentos] = useState([]);
  const [detalhesPedido, setDetalhesPedido] = useState([]); // Estado para armazenar os dados detalhados
  const { id } = useParams();

  const [filtros, setFiltros] = useState({
    NUMERO_DOC: '',
    PEDIDO_MIC: '',
    COD_OPERACAO: id, // Fixando a operação baseada no ID recebido
    NOME_REDUZIDO: ''
  });

  const showAlert = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  useEffect(() => {
    Axios.get(`https://operacao.setlogistica.com.br/api/autosaberto/${id}`)
      .then((response) => {
        setCarregamentos(response.data);
        setFilteredCarregamentos(response.data); // Inicialmente, sem filtro
      })
      .catch((error) => {
        console.error("Erro ao buscar os dados de carregamentos: ", error);
        showAlert("Erro ao buscar os dados de carregamentos", "error");
      });
  }, []);

  // Função para capturar os valores únicos para cada filtro
  const uniqueValues = (field) => {
    return [...new Set(carregamentos.map((carregamento) => carregamento[field]))];
  };

  // Atualiza o estado dos filtros conforme o usuário altera as seleções
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    const selectedCarregamento = carregamentos.find(carregamento => carregamento.NOME_NAVIO === value);

    setFiltros((prevFiltros) => ({
      ...prevFiltros,
      [name]: value,
      COD_OPERACAO: name === 'NOME_NAVIO' && selectedCarregamento ? selectedCarregamento.COD_OPERACAO : prevFiltros.COD_OPERACAO
    }));
  };


  // Busca os detalhes dos pedidos quando um navio é selecionado e `COD_OPERACAO` é definido
  useEffect(() => {
    if (filtros.COD_OPERACAO) {
      Axios.get(`https://operacao.setlogistica.com.br/api/graficdocs/pedido/${filtros.COD_OPERACAO}`)
        .then((response) => {
          setDetalhesPedido(response.data);
        })
        .catch((error) => {
          console.error("Erro ao buscar os dados dos pedidos: ", error);
          showAlert("Erro ao buscar os dados dos pedidos", "error");
        });
    }
  }, [filtros.COD_OPERACAO]);

  // Aplica os filtros e atualiza a tabela principal
  useEffect(() => {
    const filteredData = carregamentos.filter((carregamento) =>
      (filtros.NUMERO_DOC === '' || carregamento.NUMERO_DOC === filtros.NUMERO_DOC) &&
      (filtros.PEDIDO_MIC === '' || carregamento.PEDIDO_MIC === filtros.PEDIDO_MIC) &&
      (filtros.NOME_REDUZIDO === '' || carregamento.NOME_REDUZIDO === filtros.NOME_REDUZIDO)
    );
    setFilteredCarregamentos(filteredData);
  }, [filtros, carregamentos]);

  // Função para cancelar o carregamento
  const handleCancel = (id) => {
    Axios.post(`https://operacao.setlogistica.com.br/api/cancelarcarregamento/${id}`)
      .then(() => {
        showAlert("Carregamento cancelado com sucesso", "success");
        setCarregamentos(carregamentos.filter(carregamento => carregamento.ID_CARREGAMENTO !== id));
      })
      .catch((error) => {
        console.error("Erro ao cancelar o carregamento: ", error);
        showAlert("Erro ao cancelar o carregamento", "error");
      });
  };

  return (
    <>
      <Navbar motivados />
      <Header />
      <Background />
      <Container>
        <div className={style.content}>
          <div className={style.nav}>
            <div className={style.navItem} onClick={() => navigate(`/operacoes`)}>Operações</div>
            <div className={style.navItem} onClick={() => navigate(`/operacao/${id}`)}>Pesagem Funil</div>
            {/* <div className={style.navItem} onClick={() => navigate(`/operacao/pesagemfinal/${id}`)}>Pesagem de Conferência</div> */}
            <div className={style.navItem} onClick={() => navigate(`/operacao/${id}/AberturaPeriodo`)}>Abertura de Período</div>
            <div className={style.navItemActive}>{'>'} Autos Em Aberto</div>
          </div>

          <div className={style.tableContainer}>
            <div className={style.columnsContainer}>
              <div className={style.column}>
                <div className={style.logoContainer}>
                  <img src={Logo} alt="Logo" className={style.logo} />
                </div>
              </div>
              <div className={style.column}>
                <strong>Autos Aguardando Pesagem</strong>
              </div>
              <div className={style.column}>
                MV {carregamentos[0]?.NOME_NAVIO || 'Carregando...'}
              </div>

            </div>
            <table className={style.table}>
              <thead>
                <tr>
                  <th>Destinos</th>
                  <th>Saldo</th>
                  <th>Veículos</th>
                  <th>Tons</th>
                </tr>
              </thead>
              <tbody>
  {detalhesPedido.map((detalhe) => {
    const totalCapacidade = filteredCarregamentos
      .filter(carregamento => carregamento.PEDIDO_MIC === detalhe.PEDIDO_MIC)
      .reduce((acc, carregamento) => acc + (carregamento.CAPACIDADE || 0), 0);

    const saldo = (detalhe.QTDE_MANIFESTADA_PEDIDO - detalhe.PESO_LIQUIDO_POR_PEDIDO_MIC - totalCapacidade) / 1000;

    return (
      <tr
        key={detalhe.PEDIDO_MIC}
        style={{
          backgroundColor: detalhe.BLOQUEAR_PEDIDO === 'S' ? '#ffcccc' : '', // Fundo vermelho claro se bloqueado
          border: detalhe.BLOQUEAR_PEDIDO === 'S' ? '1px solid #c76f6f' : '' // Contorno vermelho se bloqueado
        }}
      >
        <td>
          <strong>{detalhe.NOME_DESTINO}</strong> {detalhe.NUMERO_DOC} ({detalhe.PEDIDO_MIC})
        </td>
        <td>
          {saldo.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })} tons
        </td>
        <td>
          {filteredCarregamentos.filter(carregamento => carregamento.PEDIDO_MIC === detalhe.PEDIDO_MIC).length}
        </td>
        <td>
          {(totalCapacidade / 1000).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })} tons
        </td>
      </tr>
    );
  })}

  {/* Linha para exibir o total geral */}
  <tr>
    <td><strong>Total</strong></td>
    <td>
      <strong>
        {detalhesPedido.reduce((acc, detalhe) => {
          const totalCapacidadeGeral = filteredCarregamentos
            .filter(carregamento => carregamento.PEDIDO_MIC === detalhe.PEDIDO_MIC)
            .reduce((accCap, carregamento) => accCap + (carregamento.CAPACIDADE || 0), 0);
          const saldoGeral = (detalhe.QTDE_MANIFESTADA_PEDIDO - detalhe.PESO_LIQUIDO_POR_PEDIDO_MIC - totalCapacidadeGeral) / 1000;
          return acc + saldoGeral;
        }, 0).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })} tons
      </strong>
    </td>
    <td>
      <strong>
        {filteredCarregamentos.length}
      </strong>
    </td>
    <td>
      <strong>
        {(detalhesPedido.reduce((acc, detalhe) => {
          const totalCapacidadeGeral = filteredCarregamentos
            .filter(carregamento => carregamento.PEDIDO_MIC === detalhe.PEDIDO_MIC)
            .reduce((accCap, carregamento) => accCap + (carregamento.CAPACIDADE || 0), 0);
          return acc + totalCapacidadeGeral;
        }, 0) / 1000).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })} tons
      </strong>
    </td>
  </tr>
</tbody>
            </table>
          </div>


          {/* Filtros */}
          <div className={style.filters}>

            <select
              name="NUMERO_DOC"
              value={filtros.NUMERO_DOC}
              onChange={handleFilterChange}
              className={style.filterSelect}
            >
              <option value="">Filtrar por DI</option>
              {uniqueValues("NUMERO_DOC").map((doc) => (
                <option key={doc} value={doc}>{doc}</option>
              ))}
            </select>

            <select
              name="PEDIDO_MIC"
              value={filtros.PEDIDO_MIC}
              onChange={handleFilterChange}
              className={style.filterSelect}
            >
              <option value="">Filtrar por Pedido</option>
              {uniqueValues("PEDIDO_MIC").map((pedido) => (
                <option key={pedido} value={pedido}>{pedido}</option>
              ))}
            </select>

            <select
              name="NOME_REDUZIDO"
              value={filtros.NOME_REDUZIDO}
              onChange={handleFilterChange}
              className={style.filterSelect}
            >
              <option value="">Filtrar por Transportadora</option>
              {uniqueValues("NOME_REDUZIDO").map((transp) => (
                <option key={transp} value={transp}>{transp}</option>
              ))}
            </select>

          </div>

          {/* Tabela de carregamentos filtrados */}
          <div className={style.tableContainer}>
            <table className={style.table}>
              <thead>
                <tr>
                  <th>ID Carregamento</th>
                  <th>Motorista</th>
                  <th>Placas</th>
                  <th>Navio</th>
                  <th>DI</th>
                  <th>Pedido</th>
                  <th>Transportadora</th>
                  <th>Lotação</th>
                  <th>Data Cadastro</th>
                </tr>
              </thead>
              <tbody>
                {filteredCarregamentos.map((carregamento) => (
                  <tr key={carregamento.ID_CARREGAMENTO}>
                    <td>{carregamento.ID_CARREGAMENTO}</td>
                    <td>
                      {carregamento.NOME_MOTORISTA ?
                        `${carregamento.NOME_MOTORISTA.split(' ')[0]} ${carregamento.NOME_MOTORISTA.split(' ').slice(-1)}` :
                        ''}
                    </td>
                    <td>
                      {carregamento.PLACA_CAVALO || carregamento.PLACA_CARRETA ? (
                        <>
                          {carregamento.PLACA_CAVALO && <>{carregamento.PLACA_CAVALO}<br /></>}
                          {carregamento.PLACA_CARRETA}
                        </>
                      ) : (
                        ''
                      )}
                    </td>
                    <td>{carregamento.NOME_NAVIO}</td>
                    <td>{carregamento.NUMERO_DOC}</td>
                    <td>{carregamento.PEDIDO_MIC}</td>
                    <td>{carregamento.NOME_REDUZIDO}</td>
                    <td>{carregamento.CAPACIDADE ? `${carregamento.CAPACIDADE.toLocaleString('pt-BR', { maximumFractionDigits: 3 })} kg` : ''}</td>
                    <td>{moment(carregamento.DATA_TARA).format('DD/MM - HH:mm')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </Container>
    </>
  );
};

export default function IntegrationNotistack() {
  return (
    <SnackbarProvider
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      maxSnack={3}
      autoHideDuration={2500}
    >
      <DashboardNitrato />
    </SnackbarProvider>
  );
};
